import React, { FC, useMemo } from 'react';
import { ControlledGlyph } from './ControlledGlyph';
import { repeat } from '../../../../utils';
import { ShipEntity, SwarmEntity } from './game';
import { randGlyph } from '../../../../traits/randGlyph';

export type ControlledSwarmProps = {
  swarmEntity: SwarmEntity;
  shipEntity: ShipEntity;
};

export const ControlledSwarm: FC<ControlledSwarmProps> = ({
  swarmEntity,
  shipEntity,
}) => {
  const [xCount, yCount, zCount] = swarmEntity.count;
  const matrices = useMemo(
    () => repeat(xCount * yCount * zCount, randGlyph),
    [xCount, yCount, zCount],
  );

  return (
    <group>
      {repeat(xCount, x =>
        repeat(yCount, y =>
          repeat(zCount, z => (
            <ControlledGlyph
              key={`${x}_${y}_${z}`}
              matrix={matrices[xCount * y + x].glyph}
              colors={matrices[xCount * y + x].colors}
              indices={[x, y, z]}
              swarmEntity={swarmEntity}
              shipEntity={shipEntity}
            />
          )),
        ),
      )}
    </group>
  );
};
